/**************  CSS  **************/
import './TrainLengthForm.css'

/**********  React hooks  **********/
import { useRef } from 'react'

/**********  Components  ***********/


/************  Others  *************/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function SpeedButton({speed, setSpeed, submit}) {
    const buttonOnclick = e => {
        e.preventDefault()
        setSpeed(speed)
        submit(e)
    }
    return <button className='tda-SpeedButton' onClick={buttonOnclick}>{speed}</button>
}

export default function TrainLengthForm({speed, setSpeed, length, setLength, submitForm}) {
    return <form onSubmit={submitForm}>
        <label>
            <p>Longueur</p>
            <hr/>
            <div class='tda-inputWithUnit'>
                <input type='number' value={length} onChange={e => setLength(e.target.value)} required/>
                <span>m</span>
            </div>
            <input type='range' min='0' max='750' value={length} onChange={e => setLength(Math.floor(e.target.value / 5) * 5)}/>
        </label>
        <label>
            <p>Vitesse</p>
            <hr/>
            <div class='tda-inputWithUnit'>
                <input type='number' value={speed} onChange={e => setSpeed(e.target.value)} required/>
                <span>km/h</span>
            </div>
            <input type='range' min='0' max='160' value={speed} onChange={e => setSpeed(Math.ceil(e.target.value / 5) * 5)}/>
            <div className='tda-FormShortcut'>
                <SpeedButton speed={20} setSpeed={setSpeed} submit={submitForm} /> 
                <SpeedButton speed={40} setSpeed={setSpeed} submit={submitForm} />
                <SpeedButton speed={60} setSpeed={setSpeed} submit={submitForm} />
                <SpeedButton speed={80} setSpeed={setSpeed} submit={submitForm} />
                <SpeedButton speed={90} setSpeed={setSpeed} submit={submitForm} />
                <SpeedButton speed={100} setSpeed={setSpeed} submit={submitForm} />
                <SpeedButton speed={110} setSpeed={setSpeed} submit={submitForm} />
                <SpeedButton speed={120} setSpeed={setSpeed} submit={submitForm} />
            </div>
        </label>
        <button type='submit'><FontAwesomeIcon icon="fa-solid fa-check" /></button>
    </form>
}